/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { formatMessage, setScreenData, Store } from 'cw-ui-core';
import { FormItem, TextInput } from '@cw-ui/form-components';
import { injectIntl } from 'react-intl';
import { ASIO_ENABLEMENT_DIALOG_ID } from './AsioEnablementDialogContainer';
import Locale from 'src/Locale';
import { Alert } from '@cw-ui/feedback-components';

const BrightGaugeConfirmationStep = props => {
  const { region, subDomainName, partnerCompany, country, brightGaugeValidationErrors } = props;

  const { dispatch } = Store() || {};

  const [formData, setFormData] = useState({companyName: partnerCompany, subDomain: subDomainName});
  const [errorMessage, setErrorMessage] = useState({});
  const regex = /^[a-zA-Z0-9]+[a-zA-Z0-9-]*[a-zA-Z0-9]+$/;

  const handleInputChange = (field, event) => {
    const rawValue = event.target.value;
    const value = field === 'subDomain' ? rawValue.replace(/\s/g, '') : rawValue;
    let error = '';

    if (!value.trim()) {
      error = `Please enter ${field === 'companyName' ? 'the Company name' : 'sub domain'}`;
    } else if (value.length > 45) {
      error = `${field === 'companyName' ? 'Company Name' : 'Sub Domain'} should not exceed 45 characters`;
    } else if (field === 'subDomain' && !regex.test(value)) {
      error = 'Please enter BrightGauge sub-domain in the acceptable format';
    }
    
    setErrorMessage(prev => ({ ...prev, [field]: error }));
    setFormData(prev => ({ ...prev, [field]: value }));
    // Check if any field has an error and pass to parent
    const hasError = Object.values({ ...errorMessage, [field]: error }).some(Boolean);
    props.validationErrors(hasError);

    dispatch(setScreenData(field, value, ASIO_ENABLEMENT_DIALOG_ID));
  };

  const handleCompanyNameChange = event => handleInputChange('companyName', event);
  const handleSubDomainChange = event => handleInputChange('subDomain', event);

  const isMobile = useMediaQuery('(min-width: 768px)');

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column'
      }}
    >
      <Typography
        variant="accordion"
        mb={0.5}
        pl={2}
        fontWeight={700}
        fontFamily="ceraPro"
        color="#27366D"
        lineHeight="25.14px"
        sx={{ fontFamily: 'sans-serif' }}
      >
        {formatMessage(Locale.connectwise_asio_platform)}
      </Typography>
      <Typography
        fontWeight={300}
        pl={2}
        fontSize={26}
        sx={{ fontFamily: 'sans-serif' }}
      >
        {formatMessage(Locale.brightgauge_confirmation_step_title)}
      </Typography>
      <Typography
        variant="paragraph"
        fontSize={13}
        sx={{ fontFamily: 'sans-serif' }}
        pl={2}
        mb={0.5}
        fontWeight={400}
        color="#767786"
        lineHeight="18px"
      >
        {formatMessage(Locale.asio_step1_sub)}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'column',
          justifyContent: 'space-between',
          fontFamily: 'sans-serif'
        }}
      >
        <Stack
          spacing={1}
          sx={{ width: isMobile ? '50%' : '100%', pl: isMobile ? 2 : 0, mt: 2 }}
        >
          {brightGaugeValidationErrors &&
            brightGaugeValidationErrors.length > 0 && (
              <Alert
                sx={{ width: 'auto' }}
                severity="error"
                onClose={() => {
                  props.onClosedIconClick();
                }}
              >
                {brightGaugeValidationErrors.map((error, index) => (
                  <ul key={index}>
                    <li>{error}</li>
                  </ul>
                ))}
              </Alert>
            )}
          {[
            {
              id: 'companyName',
              label: 'Company Name',
              value: formData.companyName || '',
              onChange: handleCompanyNameChange,
              required: true,
              error: errorMessage.companyName,
              helperText: errorMessage.companyName,
              disabled: false
            },
            {
              id: 'country',
              label: 'Country',
              value: country,
              required: false,
              error: false,
              helperText: '',
              disabled: true
            },
            {
              id: 'region',
              label: 'Region',
              value: region,
              required: false,
              error: false,
              helperText: '',
              disabled: true
            },
            {
              id: 'subDomain',
              label: 'Sub Domain',
              value: formData.subDomain || '',
              onChange: handleSubDomainChange,
              required: true,
              error: errorMessage.subDomain,
              helperText: errorMessage.subDomain,
              disabled: false
            }
          ].map(item => (
            <FormItem
              key={item.id}
              className="textInputFormControl"
              id={`${item.id}Item`}
              labelProps={{
                disabled: item.disabled,
                error: item.error,
                required: item.required
              }}
              labelText={item.label}
              shrink
              size="medium"
            >
              <TextInput
                id={item.id}
                label={item.label}
                placeholder={`Enter ${item.label}`}
                size="medium"
                value={item.value}
                required={item.required}
                error={item.error}
                helperText={item.helperText}
                onChange={item.onChange}
                disabled={item.disabled}
              />
            </FormItem>
          ))}
          <Typography
            variant="paragraph"
            fontSize={13}
            sx={{ fontFamily: 'sans-serif', marginTop: '0px !important' }}
            mb={0.5}
            fontWeight={400}
            color="#767786"
          >
            {formatMessage(Locale.subdomain_helper)}
          </Typography>
        </Stack>
        {isMobile && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '50%'
            }}
          >
            <Box
              component="img"
              src="/images/AsioPage/BrightGaugeStepper.png"
              width="350px"
              height="380px"
              alt="BrightGauge Stepper Image"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default injectIntl(BrightGaugeConfirmationStep);
